import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamps } from "./common.js";
// @generated message type with reflection information, may provide speed optimized methods
class Dispatcher$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.Dispatcher", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.Dispatcher
 */
export const Dispatcher = new Dispatcher$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DispatchGroupDeviceSummary$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.DispatchGroupDeviceSummary", [
            { no: 1, name: "device_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "device_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.deviceId = "";
        message.deviceType = "";
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string device_id */ 1:
                    message.deviceId = reader.string();
                    break;
                case /* string device_type */ 2:
                    message.deviceType = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string device_id = 1; */
        if (message.deviceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.deviceId);
        /* string device_type = 2; */
        if (message.deviceType !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.deviceType);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.DispatchGroupDeviceSummary
 */
export const DispatchGroupDeviceSummary = new DispatchGroupDeviceSummary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DispatchGroup$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.DispatchGroup", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "tso_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "timestamps", kind: "message", T: () => Timestamps },
            { no: 5, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "dispatcher_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "grid_services", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DispatchGroupGridService },
            { no: 8, name: "delivery_points_new", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DispatchGroupDeliveryPoint },
            { no: 11, name: "device_summaries", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DispatchGroupDeviceSummary }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.name = "";
        message.tsoId = "";
        message.tenantId = "";
        message.gridServices = [];
        message.deliveryPointsNew = [];
        message.deviceSummaries = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string tso_id */ 3:
                    message.tsoId = reader.string();
                    break;
                case /* dispatch_group.v1.Timestamps timestamps */ 4:
                    message.timestamps = Timestamps.internalBinaryRead(reader, reader.uint32(), options, message.timestamps);
                    break;
                case /* string tenant_id */ 5:
                    message.tenantId = reader.string();
                    break;
                case /* optional string dispatcher_id */ 12:
                    message.dispatcherId = reader.string();
                    break;
                case /* repeated dispatch_group.v1.DispatchGroupGridService grid_services */ 6:
                    message.gridServices.push(DispatchGroupGridService.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated dispatch_group.v1.DispatchGroupDeliveryPoint delivery_points_new */ 8:
                    message.deliveryPointsNew.push(DispatchGroupDeliveryPoint.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated dispatch_group.v1.DispatchGroupDeviceSummary device_summaries */ 11:
                    message.deviceSummaries.push(DispatchGroupDeviceSummary.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string tso_id = 3; */
        if (message.tsoId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.tsoId);
        /* dispatch_group.v1.Timestamps timestamps = 4; */
        if (message.timestamps)
            Timestamps.internalBinaryWrite(message.timestamps, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string tenant_id = 5; */
        if (message.tenantId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.tenantId);
        /* repeated dispatch_group.v1.DispatchGroupGridService grid_services = 6; */
        for (let i = 0; i < message.gridServices.length; i++)
            DispatchGroupGridService.internalBinaryWrite(message.gridServices[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated dispatch_group.v1.DispatchGroupDeliveryPoint delivery_points_new = 8; */
        for (let i = 0; i < message.deliveryPointsNew.length; i++)
            DispatchGroupDeliveryPoint.internalBinaryWrite(message.deliveryPointsNew[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated dispatch_group.v1.DispatchGroupDeviceSummary device_summaries = 11; */
        for (let i = 0; i < message.deviceSummaries.length; i++)
            DispatchGroupDeviceSummary.internalBinaryWrite(message.deviceSummaries[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* optional string dispatcher_id = 12; */
        if (message.dispatcherId !== undefined)
            writer.tag(12, WireType.LengthDelimited).string(message.dispatcherId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.DispatchGroup
 */
export const DispatchGroup = new DispatchGroup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DispatchGroupGridService$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.DispatchGroupGridService", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "dispatch_group_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "grid_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "market_access_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "from", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "to", kind: "scalar", opt: true, T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 7, name: "created_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 8, name: "dispatch_group", kind: "message", T: () => DispatchGroup }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.dispatchGroupId = "";
        message.gridServiceId = "";
        message.marketAccessId = "";
        message.from = 0n;
        message.createdAt = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string dispatch_group_id */ 2:
                    message.dispatchGroupId = reader.string();
                    break;
                case /* string grid_service_id */ 3:
                    message.gridServiceId = reader.string();
                    break;
                case /* string market_access_id */ 4:
                    message.marketAccessId = reader.string();
                    break;
                case /* uint64 from */ 5:
                    message.from = reader.uint64().toBigInt();
                    break;
                case /* optional uint64 to */ 6:
                    message.to = reader.uint64().toBigInt();
                    break;
                case /* uint64 created_at */ 7:
                    message.createdAt = reader.uint64().toBigInt();
                    break;
                case /* dispatch_group.v1.DispatchGroup dispatch_group */ 8:
                    message.dispatchGroup = DispatchGroup.internalBinaryRead(reader, reader.uint32(), options, message.dispatchGroup);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string dispatch_group_id = 2; */
        if (message.dispatchGroupId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.dispatchGroupId);
        /* string grid_service_id = 3; */
        if (message.gridServiceId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.gridServiceId);
        /* string market_access_id = 4; */
        if (message.marketAccessId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.marketAccessId);
        /* uint64 from = 5; */
        if (message.from !== 0n)
            writer.tag(5, WireType.Varint).uint64(message.from);
        /* optional uint64 to = 6; */
        if (message.to !== undefined)
            writer.tag(6, WireType.Varint).uint64(message.to);
        /* uint64 created_at = 7; */
        if (message.createdAt !== 0n)
            writer.tag(7, WireType.Varint).uint64(message.createdAt);
        /* dispatch_group.v1.DispatchGroup dispatch_group = 8; */
        if (message.dispatchGroup)
            DispatchGroup.internalBinaryWrite(message.dispatchGroup, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.DispatchGroupGridService
 */
export const DispatchGroupGridService = new DispatchGroupGridService$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DispatchGroupDeliveryPoint$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.DispatchGroupDeliveryPoint", [
            { no: 1, name: "dispatch_group_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "delivery_point_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "effective_from", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "effective_to", kind: "scalar", opt: true, T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "created_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "dispatch_group", kind: "message", T: () => DispatchGroup }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.dispatchGroupId = "";
        message.deliveryPointId = "";
        message.effectiveFrom = 0n;
        message.createdAt = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string dispatch_group_id */ 1:
                    message.dispatchGroupId = reader.string();
                    break;
                case /* string delivery_point_id */ 2:
                    message.deliveryPointId = reader.string();
                    break;
                case /* uint64 effective_from */ 3:
                    message.effectiveFrom = reader.uint64().toBigInt();
                    break;
                case /* optional uint64 effective_to */ 4:
                    message.effectiveTo = reader.uint64().toBigInt();
                    break;
                case /* uint64 created_at */ 5:
                    message.createdAt = reader.uint64().toBigInt();
                    break;
                case /* dispatch_group.v1.DispatchGroup dispatch_group */ 6:
                    message.dispatchGroup = DispatchGroup.internalBinaryRead(reader, reader.uint32(), options, message.dispatchGroup);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string dispatch_group_id = 1; */
        if (message.dispatchGroupId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.dispatchGroupId);
        /* string delivery_point_id = 2; */
        if (message.deliveryPointId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.deliveryPointId);
        /* uint64 effective_from = 3; */
        if (message.effectiveFrom !== 0n)
            writer.tag(3, WireType.Varint).uint64(message.effectiveFrom);
        /* optional uint64 effective_to = 4; */
        if (message.effectiveTo !== undefined)
            writer.tag(4, WireType.Varint).uint64(message.effectiveTo);
        /* uint64 created_at = 5; */
        if (message.createdAt !== 0n)
            writer.tag(5, WireType.Varint).uint64(message.createdAt);
        /* dispatch_group.v1.DispatchGroup dispatch_group = 6; */
        if (message.dispatchGroup)
            DispatchGroup.internalBinaryWrite(message.dispatchGroup, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.DispatchGroupDeliveryPoint
 */
export const DispatchGroupDeliveryPoint = new DispatchGroupDeliveryPoint$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DispatchIndicator$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.DispatchIndicator", [
            { no: 1, name: "grid_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "timestamp", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "active_power_real_w", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "assigned_capacity_up_w", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "assigned_capacity_down_w", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 7, name: "power_request_w", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 11, name: "baseline_real_w", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 12, name: "baseline_assume_w", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 13, name: "signal", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "nominal_frequency_hz", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 15, name: "active_power_assumed_w", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 16, name: "missed_power_capacity_w", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 17, name: "capacity_up_left_w", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 18, name: "capacity_down_left_w", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 19, name: "energy_capacity_up_left_w", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 20, name: "energy_capacity_down_left_w", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 21, name: "power_corrected_baseline_w", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 22, name: "device_count_assume", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 23, name: "device_count_real", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.gridServiceId = "";
        message.timestamp = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string grid_service_id */ 1:
                    message.gridServiceId = reader.string();
                    break;
                case /* uint64 timestamp */ 2:
                    message.timestamp = reader.uint64().toBigInt();
                    break;
                case /* optional int64 active_power_real_w */ 3:
                    message.activePowerRealW = reader.int64().toBigInt();
                    break;
                case /* optional int64 assigned_capacity_up_w */ 5:
                    message.assignedCapacityUpW = reader.int64().toBigInt();
                    break;
                case /* optional int64 assigned_capacity_down_w */ 6:
                    message.assignedCapacityDownW = reader.int64().toBigInt();
                    break;
                case /* optional int64 power_request_w */ 7:
                    message.powerRequestW = reader.int64().toBigInt();
                    break;
                case /* optional int64 baseline_real_w */ 11:
                    message.baselineRealW = reader.int64().toBigInt();
                    break;
                case /* optional int64 baseline_assume_w */ 12:
                    message.baselineAssumeW = reader.int64().toBigInt();
                    break;
                case /* optional string signal */ 13:
                    message.signal = reader.string();
                    break;
                case /* optional double nominal_frequency_hz */ 14:
                    message.nominalFrequencyHz = reader.double();
                    break;
                case /* optional int64 active_power_assumed_w */ 15:
                    message.activePowerAssumedW = reader.int64().toBigInt();
                    break;
                case /* optional int64 missed_power_capacity_w */ 16:
                    message.missedPowerCapacityW = reader.int64().toBigInt();
                    break;
                case /* optional int64 capacity_up_left_w */ 17:
                    message.capacityUpLeftW = reader.int64().toBigInt();
                    break;
                case /* optional int64 capacity_down_left_w */ 18:
                    message.capacityDownLeftW = reader.int64().toBigInt();
                    break;
                case /* optional int64 energy_capacity_up_left_w */ 19:
                    message.energyCapacityUpLeftW = reader.int64().toBigInt();
                    break;
                case /* optional int64 energy_capacity_down_left_w */ 20:
                    message.energyCapacityDownLeftW = reader.int64().toBigInt();
                    break;
                case /* optional int64 power_corrected_baseline_w */ 21:
                    message.powerCorrectedBaselineW = reader.int64().toBigInt();
                    break;
                case /* optional int32 device_count_assume */ 22:
                    message.deviceCountAssume = reader.int32();
                    break;
                case /* optional int32 device_count_real */ 23:
                    message.deviceCountReal = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string grid_service_id = 1; */
        if (message.gridServiceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.gridServiceId);
        /* uint64 timestamp = 2; */
        if (message.timestamp !== 0n)
            writer.tag(2, WireType.Varint).uint64(message.timestamp);
        /* optional int64 active_power_real_w = 3; */
        if (message.activePowerRealW !== undefined)
            writer.tag(3, WireType.Varint).int64(message.activePowerRealW);
        /* optional int64 assigned_capacity_up_w = 5; */
        if (message.assignedCapacityUpW !== undefined)
            writer.tag(5, WireType.Varint).int64(message.assignedCapacityUpW);
        /* optional int64 assigned_capacity_down_w = 6; */
        if (message.assignedCapacityDownW !== undefined)
            writer.tag(6, WireType.Varint).int64(message.assignedCapacityDownW);
        /* optional int64 power_request_w = 7; */
        if (message.powerRequestW !== undefined)
            writer.tag(7, WireType.Varint).int64(message.powerRequestW);
        /* optional int64 baseline_real_w = 11; */
        if (message.baselineRealW !== undefined)
            writer.tag(11, WireType.Varint).int64(message.baselineRealW);
        /* optional int64 baseline_assume_w = 12; */
        if (message.baselineAssumeW !== undefined)
            writer.tag(12, WireType.Varint).int64(message.baselineAssumeW);
        /* optional string signal = 13; */
        if (message.signal !== undefined)
            writer.tag(13, WireType.LengthDelimited).string(message.signal);
        /* optional double nominal_frequency_hz = 14; */
        if (message.nominalFrequencyHz !== undefined)
            writer.tag(14, WireType.Bit64).double(message.nominalFrequencyHz);
        /* optional int64 active_power_assumed_w = 15; */
        if (message.activePowerAssumedW !== undefined)
            writer.tag(15, WireType.Varint).int64(message.activePowerAssumedW);
        /* optional int64 missed_power_capacity_w = 16; */
        if (message.missedPowerCapacityW !== undefined)
            writer.tag(16, WireType.Varint).int64(message.missedPowerCapacityW);
        /* optional int64 capacity_up_left_w = 17; */
        if (message.capacityUpLeftW !== undefined)
            writer.tag(17, WireType.Varint).int64(message.capacityUpLeftW);
        /* optional int64 capacity_down_left_w = 18; */
        if (message.capacityDownLeftW !== undefined)
            writer.tag(18, WireType.Varint).int64(message.capacityDownLeftW);
        /* optional int64 energy_capacity_up_left_w = 19; */
        if (message.energyCapacityUpLeftW !== undefined)
            writer.tag(19, WireType.Varint).int64(message.energyCapacityUpLeftW);
        /* optional int64 energy_capacity_down_left_w = 20; */
        if (message.energyCapacityDownLeftW !== undefined)
            writer.tag(20, WireType.Varint).int64(message.energyCapacityDownLeftW);
        /* optional int64 power_corrected_baseline_w = 21; */
        if (message.powerCorrectedBaselineW !== undefined)
            writer.tag(21, WireType.Varint).int64(message.powerCorrectedBaselineW);
        /* optional int32 device_count_assume = 22; */
        if (message.deviceCountAssume !== undefined)
            writer.tag(22, WireType.Varint).int32(message.deviceCountAssume);
        /* optional int32 device_count_real = 23; */
        if (message.deviceCountReal !== undefined)
            writer.tag(23, WireType.Varint).int32(message.deviceCountReal);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.DispatchIndicator
 */
export const DispatchIndicator = new DispatchIndicator$Type();
//# sourceMappingURL=dispatch_group.js.map